import styled from 'styled-components';
import { HelpCenterContainer } from 'view/help-center/container';
import { token } from '@atlaskit/tokens';

const BOTTOM_MARGIN_PX = token('space.600', '48px');

// eslint-disable-next-line rulesdir/no-styled-export
export const Root = styled(HelpCenterContainer)`
    margin-top: ${token('space.400', '32px')};
`;

// eslint-disable-next-line rulesdir/no-styled-export
export const Description = styled.div`
    margin: 0 0 ${token('space.400', '32px')};
`;

// eslint-disable-next-line rulesdir/no-styled-export
export const ContentContainer = styled.div`
    margin-bottom: ${BOTTOM_MARGIN_PX};
`;
// eslint-disable-next-line rulesdir/no-styled-export
export const ExternalLinksListWrapper = styled.div`
    margin-top: ${token('space.400', '32px')};
`;
